import { UserCvFillIcon, UserCvIcon, UserFillIcon, UserIcon } from "@eworkit/iris";
import React, { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { getRelatedEntitiesKeys, RelatedEntities, RelatedEntityKey } from "@/data/related";

export interface RelatedEntityTabData {
  label: string;
  icon: ReactElement;
  activeIcon: ReactElement;
  count: number;
  url: string;
}

export const useRelatedEntitiesTabsData = (
  relatedEntities: RelatedEntities,
): Record<RelatedEntityKey, RelatedEntityTabData> => {
  const { t } = useTranslation("session");

  const result = {} as Record<RelatedEntityKey, RelatedEntityTabData>;

  const keys = getRelatedEntitiesKeys(relatedEntities);

  for (const key of keys) {
    result[key] = {
      label: "",
      icon: <div />,
      activeIcon: <div />,
      count: relatedEntities.counts[key] ?? 0,
      url: relatedEntities.urls[key] ?? "",
    };

    switch (key) {
      case "assignment":
        result[key].label = t("RELATED_ENTITIES.ASSIGNMENTS.TAB_NAME");
        result[key].icon = <UserCvIcon />;
        result[key].activeIcon = <UserCvFillIcon />;
        break;

      case "worker":
      case "candidate":
        result[key].label = t(`RELATED_ENTITIES.${key.toUpperCase()}.TAB_NAME`);
        result[key].icon = <UserIcon />;
        result[key].activeIcon = <UserFillIcon />;
        break;

      case "job-request":
        result[key].label = t("RELATED_ENTITIES.JOB_REQUEST.TAB_NAME");
        result[key].icon = <UserCvIcon />;
        result[key].activeIcon = <UserCvFillIcon />;
        break;

      default:
        throw new Error("RelatedEntityKey cannot be recognized");
    }
  }

  return result;
};
